/* eslint-disable no-nested-ternary */
import { Divider, Grid, NumberInput, Select, Stack, Text, TextInput } from '@mantine/core';
import { useContext } from 'react';
import { IconAlignLeft, IconBorderRadius, IconLetterCase, IconPhoto } from '@tabler/icons';
import { BookitupFormContext } from '../../../Service/Context/BookitupFormContext';
import MantineColorPicker from '../../../Atoms/inputs/MantineColorPicker';
import { WindowContext } from '../../../Service/Context/WindowContext';
import { DataS } from '../../../Service/DataS';
import GradientPicker from '../../../Atoms/inputs/GradientPicker';
import { ThemeText } from '../../../Atoms/ThemeText';

const ContactFormStyleOptions = () => {
  const { bookitupForm, bookitupFormStyles, updateFormStyles } = useContext(BookitupFormContext);
  const { xs, md } = useContext(WindowContext);
  const gridColSpanSize = xs ? 12 : md ? 6 : 4;

  if (!bookitupForm) {
    return null;
  }

  const {
    formBackgroundColor,
    backgroundImage,
    formTextColor,
    fieldBackgroundColor,
    fieldTextColor,
    fieldBorderColor,
    fieldBorderFocusColor,
    submitButtonBackgroundColor,
    submitButtonTextColor,
    fieldAsteriskColor,
    fieldBorderRadius,
    submitButtonBorderRadius,
    submitButtonPosition,
    fontFamily,
  } = bookitupFormStyles;

  return (
    <>
      <TextInput
        label="Schriftart"
        defaultValue={fontFamily ?? undefined}
        onBlur={(e) => updateFormStyles({ fontFamily: e.currentTarget.value })}
        icon={<IconLetterCase size={20} />}
        sx={{ maxWidth: 600 }}
      />
      <Text color="dimmed" size="xs" mt={5} sx={{ maxWidth: 600 }}>
        Du kannst hier eine Schriftart eintragen, die bereits auf deiner Webseite verwendet wird, damit unser Formular
        auch diese Schriftart verwendet. Mehrere Schriftarten können mit Komma getrennt aufgelistet werden, falls eine
        Schriftart nicht geladen werden kann.
      </Text>
      <TextInput
        mt="sm"
        mb="xl"
        label="Hintergrundbild"
        placeholder="http://domain.de/image-url.png"
        defaultValue={backgroundImage ?? undefined}
        onBlur={(e) => updateFormStyles({ backgroundImage: e.currentTarget.value })}
        icon={<IconPhoto size={20} />}
        sx={{ maxWidth: 600 }}
      />
      <Divider my="xs" label={<ThemeText size="md">Formular</ThemeText>} />
      <Grid mt="md" sx={{ alignItems: 'flex-start' }}>
        <Grid.Col span={gridColSpanSize}>
          <GradientPicker
            initialGradient={formBackgroundColor}
            label="Hintergrundfarbe"
            onChange={(val) => updateFormStyles({ formBackgroundColor: val })}
          />
        </Grid.Col>
        <Grid.Col span={gridColSpanSize}>
          <MantineColorPicker
            label="Textfarbe"
            color={formTextColor}
            onChange={(val) => updateFormStyles({ formTextColor: val })}
          />
        </Grid.Col>
      </Grid>
      <Divider my="xl" label={<ThemeText size="md">Feld</ThemeText>} />

      <NumberInput
        hideControls
        label=" Rundung der Eingabefelder"
        min={0}
        max={50}
        icon={<IconBorderRadius size={20} />}
        value={Number(fieldBorderRadius)}
        onBlur={(e) => e.currentTarget.value !== '' && updateFormStyles({ fieldBorderRadius: e.currentTarget.value })}
        rightSection={
          <ThemeText size="xs" weight="bolder">
            px
          </ThemeText>
        }
        sx={{ maxWidth: 600 }}
      />
      <Grid mt="md" sx={{ alignItems: 'flex-start' }}>
        <Grid.Col span={gridColSpanSize}>
          <GradientPicker
            initialGradient={fieldBackgroundColor}
            label="Hintergrundfarbe"
            onChange={(val) => updateFormStyles({ fieldBackgroundColor: val })}
          />
        </Grid.Col>
        <Grid.Col span={gridColSpanSize}>
          <MantineColorPicker
            label="Textfarbe"
            color={fieldTextColor}
            onChange={(val) => updateFormStyles({ fieldTextColor: val })}
          />
        </Grid.Col>
        <Grid.Col span={gridColSpanSize}>
          <MantineColorPicker
            label="Rahmenfarbe"
            color={fieldBorderColor}
            onChange={(val) => updateFormStyles({ fieldBorderColor: val })}
          />
        </Grid.Col>
        <Grid.Col span={gridColSpanSize}>
          <MantineColorPicker
            label="Rahmenfarbe bei Fokus"
            color={fieldBorderFocusColor}
            onChange={(val) => updateFormStyles({ fieldBorderFocusColor: val })}
          />
        </Grid.Col>
        <Grid.Col span={gridColSpanSize}>
          <MantineColorPicker
            label="Sternchenfarbe"
            color={fieldAsteriskColor}
            onChange={(val) => updateFormStyles({ fieldAsteriskColor: val })}
          />
        </Grid.Col>
      </Grid>

      <Divider my="xl" label={<ThemeText size="md">Absendebutton</ThemeText>} />
      <Stack sx={{ maxWidth: 600 }}>
        <Select
          label="Ausrichten"
          icon={<IconAlignLeft size={20} />}
          value={submitButtonPosition}
          onChange={(val) => val && updateFormStyles({ submitButtonPosition: val })}
          data={DataS.buttonPositionOptions}
        />

        <NumberInput
          hideControls
          label="Rundung vom Absendebutton"
          min={0}
          max={50}
          icon={<IconBorderRadius size={20} />}
          value={Number(submitButtonBorderRadius)}
          onBlur={(e) =>
            e.currentTarget.value !== '' && updateFormStyles({ submitButtonBorderRadius: e.currentTarget.value })
          }
          rightSection={
            <ThemeText size="xs" weight="bolder">
              px
            </ThemeText>
          }
        />
      </Stack>
      <Grid mt="md" sx={{ alignItems: 'flex-start' }}>
        <Grid.Col span={gridColSpanSize}>
          <GradientPicker
            initialGradient={submitButtonBackgroundColor}
            label="Hintergrundfarbe"
            onChange={(val) => updateFormStyles({ submitButtonBackgroundColor: val })}
          />
        </Grid.Col>
        <Grid.Col span={gridColSpanSize}>
          <MantineColorPicker
            label="Textfarbe"
            color={submitButtonTextColor}
            onChange={(val) => updateFormStyles({ submitButtonTextColor: val })}
          />
        </Grid.Col>
      </Grid>
    </>
  );
};

export default ContactFormStyleOptions;
